import { makeStyles } from '@mui/styles'
import { MEDIUM_GRAY } from '@returnmates/client-core/src/constants/colors'

const useStyles = makeStyles(() => ({
  formControl: {
    width: 179,
  },
  hubDropdownWrapper: {
    display: 'flex',
    alignItems: 'center',
    margin: '0px 10px',
    height: '100%',
  },
  hubDropdown: {
    width: 179,
  },
  form: {},
  control: {
    borderRadius: '35px',
  },
  mapPin: {
    width: 24,
    height: 24,
  },
  startAdornment: {
    margin: '0 9px 0 14px',
  },
  endAdornment: {
    marginRight: 10,
    marginLeft: 0,
  },
  select: {
    borderRadius: '4px',
    border: `1px solid ${MEDIUM_GRAY} !important`,
    height: 36,

    '&:hover, &:focus': {
      border: `1px solid ${MEDIUM_GRAY}`,
    },

    '& > svg': {
      width: 24,
      height: 24,
      top: '50%',
      transform: 'translateY(-50%)',
      right: 10,
    },
  },

  '@media(max-width: 1024px)': {
    hubDropdownWrapper: {
      marginRight: 250,
      padding: '0 10px',
    },
  },
}))

export default useStyles
